module.exports = __webpack_public_path__ + "static/media/overweight.9c9a3ea3.png";